module.exports = "/_next/static/images/image-invest-text-bdadccd65123738e2bacee2738e3afa6.svg";